import * as React from 'react';

function SvgRemove(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M2 12c0-.442.385-.8.86-.8h18.28c.475 0 .86.358.86.8 0 .442-.385.8-.86.8H2.86c-.475 0-.86-.358-.86-.8z", clipRule: "evenodd" })));
}

export default SvgRemove;
